// extracted by mini-css-extract-plugin
module.exports = {"account__offers":"account__offers-1ZQ3x","checkbox":"checkbox-BgcC3","checked":"checked-2085H"};